/************************************
MODULE:         TABS CLASS
WHAT IT DOES:   all tabs logic is here
*************************************/
(function(root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        root.returnExports = factory(root.jQuery);
    }
})(this, function($) {
    function Tabs(el, options) {
        var helpers= require('modules/helpers');
        this.settings = $.extend({}, this._defaults, options || {});
        this.tablist = $(el);
        this.container = null;
        this.controller = null;
        this.tabs = null;
        this.carousel = null;
        this.tween = null;
        this.tween1 = null;

        this.init();
        $(window).on('resize:finished tabs:resize', this.resize.bind(this));
        this.tablist.on('tab:resize', this.resize.bind(this));
        this.tablist[0].addEventListener('load', helpers.debounce(this.resize.bind(this), 400), true);

    }

    Tabs.prototype = {
        _defaults: {
            effect: 'none', // scale / slideleft / slideright / slidetop / slidedown / none
            defaultTab: null,
            carouseled: false,
            tabsPosition: 'horizontal', // horizontal / vertical
            horizontalPosition: 'top', // top / bottom
            verticalPosition: 'left', // left / right
            theme: '' // 'name' - string
        },

        arEffects: ['scale', 'slideleft', 'slideright', 'slidetop', 'slidedown', 'none', 'js'],
        init: function() {
            this.tablist.addClass('tabs_list');
            this.tablist.wrap('<div class="tabs_container"></div>');

            this.tabs = this.tablist.children('[data-tab]');
            this.container = this.tablist.parent('.tabs_container');

            this.setTabContainerClasses();

            var controlls = this.createControlsOrTabs();
            this.setControllsToCorrectPos(controlls);

            this.tabs = this.tablist.children('[data-tab]');
            this.tabs.addClass('tab_hide');

            this.controller = controlls.find('a');

            if (this.settings.tabsPosition == 'vertical') {
                var verticalTabsWidth = this.controller.outerWidth() + 1,
                    verticalTabsHeight = controlls.outerHeight(),
                    verticalContentWidth = this.container.outerWidth() - verticalTabsWidth,
                    verticalContentHeight = this.tablist.outerHeight();

                controlls.width(verticalTabsWidth);
                this.tablist.outerWidth(verticalContentWidth);

                if (verticalContentHeight < verticalTabsHeight)
                    this.tablist.css('min-height', verticalTabsHeight);
            }

            if (this.settings.effect == 'js') {
                var tweenmax = require('tweenmax');
            }

            var defaultTab = this.settings.defaultTab
                ? this.tablist.find('[data-tab="' + this.settings.defaultTab + '"]')
                : this.tabs.first();
            defaultTab.removeClass('tab_hide');
            defaultTab.addClass('tab_show');

            var defaultTabImages = defaultTab.find(".lazy");
			for (var k=0;k<defaultTabImages.length;k++){
				$(defaultTabImages[k]).removeClass("hide");
			}

            this.tabs
                .not(defaultTab)
                .find('.js-sf-carousel')
                .trigger('carousel:play');

            this.container
                .find('[data-tab-id="' + defaultTab.data('tab') + '"]')
                .addClass('tab_active');
            this.iniControllsCarousel(controlls);

            this.resize();
            require('jquery.waitforimages');
            defaultTab.waitForImages(
                this.resize.bind(this),
                function(loaded, count, success) {},
                true
            );

            this.controller.on('click', this.tabLinkClick.bind(this));

            var LazyLoad = require("vanilla-lazyload");
            var lazyLoadInstance = new LazyLoad({
                elements_selector: ".lazy",
                to_webp: true,
                skip_invisible:false
            });
        },

        resize: function() {
            if (this.settings.effect == 'js') {
                var currentTab = this.tabs.filter('.tab_show'),
                    curremtTabHeight = Math.ceil(currentTab.outerHeight(true)),
                    minHei = parseInt(this.tablist.css('min-height'));
                if (currentTab.hasClass('noload') || curremtTabHeight == minHei) return;
                this.animateHeight(minHei, curremtTabHeight);
            }
        },

        animateHeight: function(oldHeight, newHeight, time) {
            var newtime = typeof time != 'undefined' ? time : 0.5;
            this.tweenPromote(this.tween1);
            this.tween1 = new TimelineMax({ onComplete: this.tweenComplete.bind(this) });
            this.tween1.to(this.tablist, newtime, { minHeight: newHeight });
            this.tween1.play();
        },

        switchSlides: function(oldTab, newTab) {
            if (this.settings.effect == 'js') {
                this.tweenPromote(this.tween);
                this.tween = new TimelineMax({
                    onComplete: this.tweenSwitchClassChange.bind(this, oldTab, newTab)
                });
                this.tween.fromTo(newTab, 0.0, { visibility: 'hidden' }, { visibility: 'visible' });
                this.tween.fromTo(newTab, 0.5, { opacity: 0 }, { opacity: 1 });
                this.tween.fromTo(oldTab, 0.5, { opacity: 1 }, { opacity: 0 }, '-=0.5');
                this.tween.fromTo(oldTab, 0.0, { visibility: 'visible' }, { visibility: 'hidden' });
                if (!(newTab.hasClass('loading') || newTab.hasClass('noload'))) {
                    this.animateHeight(this.tablist.outerHeight(), newTab.outerHeight());
                } else {
                    newTab.find('.loader').css('min-height', oldTab.outerHeight());
                }
                this.tween.play();
            } else {
                this.tweenSwitchClassChange(oldTab, newTab);
            }

			var images = $(newTab).find(".lazy");
			for (var k=0;k<images.length;k++){
				$(images[k]).removeClass("hide");
			}
        },

        tweenComplete: function() {
            this.container.parents('.js-tabs').trigger('tab:resize');
        },

        tweenSwitchClassChange: function(oldTab, newTab) {
            oldTab.find('.js-sf-carousel').trigger('carousel:pause');
            this.tabs
                .filter('.tab_show')
                .removeClass('tab_show')
                .addClass('tab_hide');
            newTab.addClass('tab_show');
            this.tabs.removeAttr('style');
            newTab.find('.js-sf-carousel').trigger('carousel:play');
            this.container.parents('.js-tabs').trigger('tab:resize');
        },

        tweenPromote: function(tween) {
            if (typeof tween == 'undefined' || tween == null) return;

            if (typeof tween.progress == 'function' && tween.progress() < 1) {
                tween.pause();
                tween.progress(1);
            }
            if (typeof tween.destroy == 'function') {
                tween.destroy();
            }
        },

        //just sets classes to container depending on settings
        setTabContainerClasses: function() {
            var className = '';

            if (this.settings.tabsPosition == 'vertical') {
                className +=
                    this.settings.verticalPosition == 'left'
                        ? ' tabs_vertical tabs_vertical_left'
                        : ' tabs_vertical tabs_vertical_right';
            } else {
                className +=
                    this.settings.horizontalPosition == 'top'
                        ? ' tabs_horizontal tabs_horizontal_top'
                        : ' tabs_horizontal tabs_horizontal_bottom';
            }

            if (this.settings.effect == 'none') {
                className += ' tabs_noeffect';
            }

            if (this.settings.theme) {
                className += ' ' + this.settings.theme;
            }

            if ($.inArray(this.settings.effect, this.arEffects) >= 0) {
                className += ' ' + this.settings.effect;
            } else {
                className += ' scale';
            }

            this.container.addClass(className);
        },

        createControlsOrTabs: function() {
            var controlls = this.container.find('.tabs_controll');
            //if there are no contols defined
            if (!controlls.length) {
                controlls = $('<ul class="tabs_controll"></ul>');

                var insides = '';

                for (var i = 0, l = this.tabs.length; i < l; i++) {
                    var $this = this.tabs.eq(i),
                        id = $this.data('tab'),
                        title = $this.data('tab-name');

                    $this.addClass('tab_single');

                    insides += '<li><a data-tab-id="' + id + '">' + title + '</a></li>';
                }

                controlls.html(insides);
            } else {
                var controller = controlls.find('a'),
                    insidesTab = '';

                for (var i = 0, l = controller.length; i < l; i++) {
                    var link = controller.eq(i),
                        id = link.attr('data-tab-id'),
                        tab = this.tabs.filter('[data-tab="' + id + '"]');

                    if (!tab.length)
                        insidesTab +=
                            '<div data-tab="' +
                            id +
                            '" class="noload tab_single"><div class="loader"></div></div>';
                }

                this.tabs.last().after($(insidesTab));
            }

            return controlls;
        },

        //move or add contolls to a certain position within DOM
        setControllsToCorrectPos: function(controlls) {
            if (this.settings.tabsPosition == 'vertical') {
                this.settings.verticalPosition == 'left'
                    ? this.container.prepend(controlls)
                    : this.container.append(controlls);
            } else {
                // Horizontal
                this.settings.horizontalPosition == 'top'
                    ? this.container.prepend(controlls)
                    : this.container.append(controlls);
            }
        },

        iniControllsCarousel: function(controlls) {
            if (!this.settings.carouseled == true) return;

            controlls.addClass('tabs_carousel');

            require('owl.carousel');

            this.carousel = controlls;
            this.carousel.on('initialized.owl.carousel', this.updateCarousel.bind(this));
            $(document).on('popup:loaded', this.updateCarousel.bind(this));
            this.carousel.owlCarousel({
                loop: false,
                nav: true,
                navText: [
                    '<span class="tabs_carousel--prev-inner"><svg class="icon-arrow-thin-left"><use xlink:href="#icon-arrow-thin-left"></use></svg></span>',
                    '<span class="tabs_carousel--next-inner"><svg class="icon-arrow-thin-right"><use xlink:href="#icon-arrow-thin-right"></use></svg></span>'
                ],
                navClass: ['owl-prev tabs_carousel--prev', 'owl-next tabs_carousel--next'],
                responsive: {
                    0: {
                        items: 3
                    },
                    768: {
                        items: 5
                    }
                }
            });
        },

        updateCarousel: function() {
            if (!this.carousel) return;

            var items = this.carousel.find('.owl-item'),
                active = this.carousel.find('.tab_active').parents('.owl-item'),
                index = items.index(active),
                len = items.length;

            if (isNaN(index)) return;

            index = Math.max(0, window.App.globals.isMobileSmall ? index : index - 2);
            index = Math.min(index, window.App.globals.isMobileSmall ? len - 3 : len - 5);

            this.carousel.trigger('to.owl.carousel', [index, 500, true]);
        },

        //process tab reload
        tabLinkClick: function(e) {
            if (typeof e != 'undefined' && typeof e.preventDefault == 'function')
                e.preventDefault();

            var link = $(e.target);
            if (!link.is('a')) link = link.parents('a');

            if (link.hasClass('tab_active')) {
                return;
            }

            this.controller.removeClass('tab_active');
            link.addClass('tab_active');

            $(window).trigger('video:pause');

            var tabId = link.data('tab-id');
            var currentTab = this.container.find('[data-tab="' + tabId + '"]');

            if (currentTab.hasClass('noload')) {
                currentTab.addClass('loading');
                currentTab.removeClass('noload');
                var self = this;
                $.ajax({
                    url: link.attr('href'),
                    success: function(data) {
                        currentTab.append(
                            $(data)
                                .find('[data-tab="' + tabId + '"]')
                                .children()
                        );
                        $(window).trigger('tabs:init');
                        $(window).trigger('video:init');
                        $(window).trigger('carousels:init');
                        $(window).trigger('popup:reinit');
                        $(window).trigger('gatracking:init');
                        $(window).trigger('fixonscroll:reinit');
                        $(window).trigger('sizeconvertlinks:reinit');

                        var tween = new TimelineMax(),
                            loader = currentTab.find('.loader');
                        tween.fromTo(loader, 0.5, { opacity: 1 }, { opacity: 0 });
                        tween.to(loader, 0.5, { minHeight: currentTab.outerHeight() }, '-=0.5');
                        tween.to(loader, 0.0, { visibility: 'hidden' });
                        tween.play();
                        currentTab.removeClass('loading');
                        require('jquery.waitforimages');
                        if (self.settings.effect == 'js') {
                            self.animateHeight(
                                self.tablist.outerHeight(),
                                currentTab.outerHeight(true)
                            );
                            currentTab.waitForImages(
                                self.resize.bind(self),
                                function(loaded, count, success) {},
                                true
                            );
                        } else this.container.parents('.js-tabs').trigger('tab:resize');
                    },
                    error: function(data) {
                        currentTab.addClass('noload');
                    }
                });
            }

            this.updateCarousel();

            this.switchSlides(this.tabs.filter('.tab_show'), currentTab);

        }
    };

    return Tabs;
});



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/generic/generic.tab.js
 ** module id = 29
 ** module chunks = 5
 **/